import React from "react";
import { useNavigate } from "react-router-dom";

export default function BackButton({ to = "/dashboard", label = "Back to Dashboard" }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      className="bg-orange-600 hover:bg-orange-700 px-4 py-2 rounded text-white"
    >
      ← {label}
    </button>
  );
}
